import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddnewComponent } from './addnew/addnew.component';
import { MasterpoliciesComponent } from './masterpolicies.component';
import { PremiumtransactionsComponent } from './premiumtransactions/premiumtransactions.component';

const routes: Routes = [
  {
    path:'masterpolicies',
    component:MasterpoliciesComponent
  },
  {
    path:'premiumtransactions',
    component:PremiumtransactionsComponent
  },
  {
    path:'addnew',
    component:AddnewComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MasterpoliciesRoutingModule { }
